import qs from 'qs';
import ApiResourceManager from '../ApiResourceManager';
import { normaliseOrder } from '../../helpers/OrderMethodAliases';

/** The order list or order of a response, with on-site orders under the dashboard's names. */
export function normaliseOrdersResponse(response) {
  const body = response?.data;

  if (!response?.success || !body) {
    return response;
  }

  return {
    ...response,
    data: {
      ...body,
      data: Array.isArray(body.data) ? body.data.map(normaliseOrder) : normaliseOrder(body.data),
    },
  };
}

export default class OrdersManager extends ApiResourceManager {
  get = async (params) =>
    normaliseOrdersResponse(
      await this.request({
        method: 'GET',
        url: '/orders',
        params,
        paramsSerializer: qs.stringify,
      }),
    );

  show = async (id) =>
    normaliseOrdersResponse(
      await this.request({
        method: 'GET',
        url: `/orders/${id}`,
      }),
    );

  generateReceipt = (id) =>
    this.request({
      method: 'POST',
      url: `/orders/${id}/receipt`,
    });

  createDummyOrder = (data = { is_scheduled: false }) =>
    this.request({
      method: 'POST',
      url: '/dummy-orders',
      data,
    });
}
